import { render, staticRenderFns } from "./sendTest.vue?vue&type=template&id=6d0ca8fc&scoped=true&"
import script from "./sendTest.vue?vue&type=script&lang=js&"
export * from "./sendTest.vue?vue&type=script&lang=js&"
import style0 from "./sendTest.vue?vue&type=style&index=0&id=6d0ca8fc&scoped=true&lang=scss&"
import style1 from "./sendTest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0ca8fc",
  null
  
)

export default component.exports